import * as S from './Button.styled';

export default S.Button;
